// @ts-strict-ignore
/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'
import Imgix from 'react-imgix'

export const cf2imgix = (cfUrl = '', params = {}) => {
  const url = global.decodeURIComponent(
    cfUrl
      .replace(/(https?:)?\/\/(downloads|images).ctfassets.net\//g, 'https://img.money.co.uk/')
      // imgix expects unencoded string for URL and treats + as encoded space
      .replace(/\+/g, ' '),
  )

  return url ? `${url}?${new URLSearchParams(params).toString()}` : ''
}

const pxToInt = (input) => parseInt(String(input).replace('px', ''))

const ImgixImage = ({
  src,
  width = undefined,
  height = undefined,
  sizes = undefined,
  alt,
  className = '',
  itemProp = undefined,
  critical = undefined,
  ...props
}) => {
  if (!src) {
    return (
      <div
        className={className}
        sx={{
          backgroundColor: 'light-2',
          display: 'inline-block',
        }}
      ></div>
    )
  }

  if (src.endsWith('.svg')) {
    if (typeof critical !== 'undefined') {
      console.warn("Lazy loading isn't supported with SVG images") // eslint-disable-line no-console
    }

    return (
      <img
        src={cf2imgix(src)}
        alt={alt}
        className={className}
        height={height && pxToInt(height)}
        width={width && pxToInt(width)}
        {...{ ...props, dispatch: undefined }}
      />
    )
  }

  return (
    <Imgix
      htmlAttributes={{ alt, itemProp }}
      attributeConfig={
        !critical && {
          src: 'data-src',
          srcSet: 'data-srcset',
          sizes: 'data-sizes',
        }
      }
      className={`${!critical ? 'lazyload ' : ''}${className}`}
      src={cf2imgix(src)}
      height={height && pxToInt(height)}
      width={width && pxToInt(width)}
      sizes={sizes}
      {...props}
    />
  )
}

export default React.memo(ImgixImage)
